import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import ReactGA from 'react-ga4';
import DIRECT_UI_IMAGE from '../../../../assets/images/direct_ui.png';
import { ampli } from '../../../../ampli';

export const GoToUserSellTractorSection = () => {
  const navigate = useNavigate();

  return (
    <Container>
      <ImageWrapper path={DIRECT_UI_IMAGE} />

      <ContentsContainer>
        <TextSection>
          <Title>{'트랙터 판매하기 💰'}</Title>
          <Description>{'회원간 중고 트랙터를 수수료 없이\n직접 사고 팔 수 있어요!'}</Description>
        </TextSection>

        <Button
          onClick={() => {
            ampli.pvmClickSellTractorButton({
              page_type: 'home',
            });
            ReactGA.event('pvm_click_sell_tractor_button', {
              category: 'home',
              action: 'pvm_click_sell_tractor_button',
            });
            navigate('/survey/entry/sell-tractor');
          }}
        >
          <ButtonText>{'내 트랙터 팔기'}</ButtonText>
        </Button>
      </ContentsContainer>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  padding: 32px var(--radius-large, 16px);
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: var(--radius-large, 16px);
  align-self: stretch;

  margin-bottom: 32px;

  background: var(--Light-Scheme-Monochrome-black, #232429);

  position: relative;

  overflow: hidden;
`;

const ImageWrapper = styled.div<{ path: string }>`
  width: 528px;
  height: 312.615px;

  position: absolute;

  opacity: 0.15;
  background: ${(props) => `url(${props.path}) 50% / cover no-repeat`};
`;

const ContentsContainer = styled.div`
  display: flex;
  padding: 24px 48px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: var(--radius-large, 16px);

  border-radius: var(--radius-large, 16px);
  border: 1px solid #5d5d5d;
  background: rgba(133, 136, 148, 0.2);
  box-shadow: 4px 4px 48px 0px rgba(0, 0, 0, 0.24);
  backdrop-filter: blur(8px);
`;

const TextSection = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: var(--radius-medium, 8px);
  align-self: stretch;
`;

const Title = styled.span`
  color: var(--Light-Scheme-Monochrome-white, #fff);
  text-align: center;

  /* Display/X-Large/xl-bold */
  font-family: Pretendard;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 130%; /* 23.4px */
`;

const Description = styled.pre`
  color: var(--Light-Scheme-Monochrome-grey40, #c6c6d5);
  text-align: center;

  /* Display/Medium/m-regular */
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 130%; /* 18.2px */
`;

const Button = styled.button`
  width: 150px;
  max-height: 40px;

  display: flex;
  padding: 16px;
  justify-content: center;
  align-items: center;
  gap: 4px;

  border-radius: var(--radius-medium, 8px);
  background: var(--Light-Scheme-Color-primary-blue, #445eff);
`;

const ButtonText = styled.span`
  color: var(--Light-Scheme-Monochrome-white, #fff);

  /* System/Medium/m-medium */
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 85%; /* 11.9px */
`;
